<ng-content select="[your-rank]"></ng-content>

<highcharts-chart class="chart" [Highcharts]="Highcharts" [options]="options"></highcharts-chart>
